/* This example requires Tailwind CSS v2.0+ */
// import { useContext} from 'react';

import Mapbox from './Mapbox';
// import Warning from './Warning';
// import { FarmContext } from './FarmContext';
import Notifications from './Notifications';

// function BottomControl ({ children }) { 
//   return <div className="absolute bottom-2 text-center w-full max-h-40 overflow-y-auto">
//       <div className="bg-white inline-block p-2">
//         {children}
//       </div>
//   </div>
// }

// TODO NDVI and soils should give "No Boundary warning"
export default function Main () {
  // const { boundary } = useContext(FarmContext);

  return <div>
  	<Notifications />
	{/*    {(boundary.features.length === 0) && <Notification>
      <Warning text="Zoom in and right click on a parcel, or draw a farm boundary." />
    </Notification>}*/}

    <Mapbox/>
  </div>
}

